import { render, staticRenderFns } from "./SourceDetailPanel.vue?vue&type=template&id=093e5e88&scoped=true&"
import script from "./SourceDetailPanel.vue?vue&type=script&lang=js&"
export * from "./SourceDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./SourceDetailPanel.vue?vue&type=style&index=0&id=093e5e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093e5e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
